import { render, staticRenderFns } from "./surface_contributors.vue?vue&type=template&id=2d653cac&"
import script from "./surface_contributors.vue?vue&type=script&lang=js&"
export * from "./surface_contributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports